import { TagsAdvancedRuleValue } from './TagsAdvancedRuleValue';


export const TAG_CATEGORY_RESPONSES_RULE_FIELD = 'tag_category_responses';
export const TAG_CATEGORY_COMBO_UI_CONDITION_FIELD = 'tag_category_responses_combo';

export interface TagCategoryResponsesRuleField {
  field: 'tag_category_responses';
  entity: 'entity' | 'entity_connection' | 'calendar_event_response';
  operator: 'include having any' | 'exclude having any';
  value: TagCategoryResponseRuleValue;
}


export interface TagCategoryResponseRuleValue {
  tag_category_ids: string[];
}
